import type { PremiumInvitePublicConfig } from "@/lib/premiumInvitePublicConfig";
import {
  resolveFreeJoinTelegramUrl,
  resolveFreeJoinTelegramUrlByCountry,
} from "@/lib/resolveFreeJoinTelegramUrl";

/**
 * URL del canal Telegram **gratis** (admin Invitación premium → `free_telegram_url`, o env).
 * Misma regla que DualCTA / Mux free-join y BioTemplatePremiumSimple.
 * @see resolveFreeJoinTelegramUrl
 * @see resolveFreeJoinTelegramUrlByCountry
 */
export function resolvePremiumInviteFreeTelegramUrl(
  publicConfig: PremiumInvitePublicConfig | null | undefined,
  countryCode?: string | null,
): string | undefined {
  if (countryCode != null && String(countryCode).trim()) {
    return resolveFreeJoinTelegramUrlByCountry(publicConfig, countryCode);
  }
  return resolveFreeJoinTelegramUrl(publicConfig);
}
